import { render, staticRenderFns } from "./pageTips.vue?vue&type=template&id=1814708e&scoped=true&"
import script from "./pageTips.vue?vue&type=script&lang=js&"
export * from "./pageTips.vue?vue&type=script&lang=js&"
import style0 from "./pageTips.vue?vue&type=style&index=0&id=1814708e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1814708e",
  null
  
)

export default component.exports